import { ArcherContainer, ArcherElement } from 'react-archer';
import { InfoCard } from '../info-card/info-card';
import { RoomCard } from '../room-card/room-card';
import { CareerPathSelector } from '../career-path-selector/career-path-selector';
import { UpgradeToPremium } from '../upgrade-to-premium/upgrade-to-premium';
import { ROOM_CODES } from '../../roadmap.constants';
import { useRoadmapHook } from '../../roadmap.helpers';
import { useGetFreeRoadmapQuery } from '../../roadmap.slice';
import { RoadmapVariant } from '../../roadmap.types';
import { StyledArrowAnchor, StyledCyberSecurityBasicsContainer, StyledCyberSecurityCareerSkillsContainer, StyledFreeRoadmapEnd, StyledFreeRoadmapSecurityAnalyst, StyledFreeRoadmapSelectedPath, StyledFreeRoadmapSelectedPathWrapper, StyledFreeRoadmapWrapper, StyledFundamentalSkillsContainer, StyledLink } from './free-roadmap.styles';
export const FreeRoadmap = ({
  switchToPremium,
  roomProgressData,
  variant
}: {
  switchToPremium: () => void;
  roomProgressData?: {
    roomCode: string;
    progressPercentage: number;
  }[];
  variant: RoadmapVariant;
}) => {
  const {
    data
  } = useGetFreeRoadmapQuery();
  const {
    isMobile,
    arrowStyle,
    selectedOption,
    setSelectedOption
  } = useRoadmapHook();
  const roomCard = (code: string) => {
    const progress = roomProgressData?.find(d => d.roomCode === code)?.progressPercentage ?? 0;
    return <RoomCard key={code} room={data?.data?.[code]} progress={progress} data-sentry-element="RoomCard" data-sentry-component="roomCard" data-sentry-source-file="free-roadmap.tsx" />;
  };
  const isWelcomeVariant = variant === 'welcome';
  return <ArcherContainer strokeColor="rgba(62, 71, 90, 1)" svgContainerStyle={{
    zIndex: '-1'
  }} noCurves data-sentry-element="ArcherContainer" data-sentry-component="FreeRoadmap" data-sentry-source-file="free-roadmap.tsx">
      <StyledFreeRoadmapWrapper data-sentry-element="StyledFreeRoadmapWrapper" data-sentry-source-file="free-roadmap.tsx">
        <ArcherElement id="archer-free-1" relations={[{
        targetId: 'archer-free-2',
        targetAnchor: 'top',
        sourceAnchor: 'bottom',
        ...arrowStyle
      }]} data-sentry-element="ArcherElement" data-sentry-source-file="free-roadmap.tsx">
          <StyledCyberSecurityBasicsContainer data-sentry-element="StyledCyberSecurityBasicsContainer" data-sentry-source-file="free-roadmap.tsx">
            <InfoCard title="Cyber Security Basics" subtitle="Acquire the basic cyber security skills required to get started in cyber security." background data-sentry-element="InfoCard" data-sentry-source-file="free-roadmap.tsx" />
          </StyledCyberSecurityBasicsContainer>
        </ArcherElement>
        {ROOM_CODES.cyberBasics.map(code => roomCard(code))}
        <ArcherElement id="archer-free-2" relations={[{
        targetId: 'archer-free-3',
        targetAnchor: 'top',
        sourceAnchor: 'bottom',
        ...arrowStyle
      }]} data-sentry-element="ArcherElement" data-sentry-source-file="free-roadmap.tsx">
          <StyledFundamentalSkillsContainer data-sentry-element="StyledFundamentalSkillsContainer" data-sentry-source-file="free-roadmap.tsx">
            <InfoCard title="Fundamental skills" subtitle="Acquire the fundamental skills needed to enter any career in the industry." background data-sentry-element="InfoCard" data-sentry-source-file="free-roadmap.tsx" />
          </StyledFundamentalSkillsContainer>
        </ArcherElement>
        {ROOM_CODES.fundementals.map(code => roomCard(code))}
        <StyledCyberSecurityCareerSkillsContainer data-sentry-element="StyledCyberSecurityCareerSkillsContainer" data-sentry-source-file="free-roadmap.tsx">
          <ArcherElement id="archer-free-3" relations={[{
          targetId: 'archer-free-security-analyst-1',
          targetAnchor: 'top',
          sourceAnchor: 'bottom',
          ...arrowStyle
        }, {
          targetId: 'archer-free-pentester-1',
          targetAnchor: 'top',
          sourceAnchor: 'bottom',
          ...arrowStyle
        }, {
          targetId: 'archer-free-security-engineer-1',
          targetAnchor: 'top',
          sourceAnchor: 'bottom',
          ...arrowStyle
        }]} data-sentry-element="ArcherElement" data-sentry-source-file="free-roadmap.tsx">
            <div>
              {isMobile ? <CareerPathSelector selectedOption={selectedOption} handleSelection={setSelectedOption} variant={variant} /> : <InfoCard title="Cyber Security Career Skills" subtitle={<p>
                      {isWelcomeVariant ? 'Master the specific skills necessary for your career of interest.' : <>
                          Master the specific skills necessary for your career of interest. Not sure which career path
                          is right for you? Take our{' '}
                          <a href="/r/careers/quiz" target="_blank" rel="noreferrer">
                            career quiz
                          </a>{' '}
                          to find out.
                        </>}
                    </p>} background />}
            </div>
          </ArcherElement>
        </StyledCyberSecurityCareerSkillsContainer>
        <StyledFreeRoadmapSelectedPathWrapper data-sentry-element="StyledFreeRoadmapSelectedPathWrapper" data-sentry-source-file="free-roadmap.tsx">
          {(!isMobile || isMobile && selectedOption?.value === 'security-analyst') && <StyledFreeRoadmapSecurityAnalyst>
              <ArcherElement id="archer-free-security-analyst-1" relations={[{
            targetId: 'archer-free-security-analyst-2',
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            style: {
              endMarker: false,
              ...arrowStyle.style
            }
          }]}>
                <div>
                  <InfoCard title="Security Analyst" subtitle={<p>
                        Master your first steps to become a{' '}
                        <a href="/r/careers/cyber-security-analyst" target="_blank" rel="noreferrer">
                          Security Analyst
                        </a>
                        .
                      </p>} background={false} />
                </div>
              </ArcherElement>
              {ROOM_CODES.securityAnalyst.map(code => roomCard(code))}
              <ArcherElement id="archer-free-security-analyst-2" relations={[{
            targetId: 'archer-bottom',
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            ...arrowStyle
          }]}>
                <StyledArrowAnchor />
              </ArcherElement>
            </StyledFreeRoadmapSecurityAnalyst>}
          {(!isMobile || isMobile && selectedOption?.value === 'pentester') && <StyledFreeRoadmapSelectedPath flexDirection="column" justifyContent="flex-start" style={{
          position: 'relative'
        }}>
              <ArcherElement id="archer-free-pentester-1" relations={[{
            targetId: 'archer-free-pentester-2',
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            style: {
              endMarker: false,
              ...arrowStyle.style
            }
          }]}>
                <div>
                  <InfoCard title="Penetration Tester" subtitle={<p>
                        Master your first steps to become a{' '}
                        <a href="r/careers/penetration-tester" target="_blank" rel="noreferrer">
                          Penetration Tester
                        </a>
                        .
                      </p>} background={false} />
                </div>
              </ArcherElement>
              {ROOM_CODES.pentester.map(code => roomCard(code))}
              <ArcherElement id="archer-free-pentester-2" relations={[{
            targetId: 'archer-bottom',
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            ...arrowStyle
          }]}>
                <StyledArrowAnchor />
              </ArcherElement>
            </StyledFreeRoadmapSelectedPath>}
          {(!isMobile || isMobile && selectedOption?.value === 'security-engineer') && <StyledFreeRoadmapSelectedPath>
              <ArcherElement id="archer-free-security-engineer-1" relations={[{
            targetId: 'archer-free-security-engineer-2',
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            style: {
              endMarker: false,
              ...arrowStyle.style
            }
          }]}>
                <div>
                  <InfoCard title="Security Engineer" subtitle={<p>
                        Master your first steps to become a{' '}
                        <a href="/r/careers/security-engineer" target="_blank" rel="noreferrer">
                          Security Engineer
                        </a>
                        .
                      </p>} background={false} />
                </div>
              </ArcherElement>
              {ROOM_CODES.securityEngineer.map(code => roomCard(code))}
              <ArcherElement id="archer-free-security-engineer-2" relations={[{
            targetId: 'archer-bottom',
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            ...arrowStyle
          }]}>
                <StyledArrowAnchor />
              </ArcherElement>
            </StyledFreeRoadmapSelectedPath>}
        </StyledFreeRoadmapSelectedPathWrapper>
        {(!isMobile || isMobile && selectedOption !== undefined) && <>
            <ArcherElement id="archer-bottom">
              <StyledFreeRoadmapEnd>
                <InfoCard title="Pursue a career in cyber security" subtitle={<p>
                      To pursue a career in cyber security, it&apos;s essential to follow a structured learning path.
                      Subscribe to follow the{' '}
                      <StyledLink type="button" onClick={switchToPremium}>
                        premium roadmap
                      </StyledLink>{' '}
                      and gain the guidance and resources needed to achieve your career goals.
                    </p>} background={false} styles={{
              maxWidth: '68rem'
            }} />
              </StyledFreeRoadmapEnd>
            </ArcherElement>
            <UpgradeToPremium />
          </>}
      </StyledFreeRoadmapWrapper>
    </ArcherContainer>;
};